module.exports = __webpack_public_path__ + "static/media/helicopter-v2.d77feebe.png";